<template>
  <form class="space-y-6"
        @submit.prevent="register">
    <div class="space-y-1">
      <inputs-label for="name" title="Name"/>

      <inputs-text id="name" :required="true" class="col-span-6 sm:col-span-3" placeholder="Joe Doe"
                   @set="form.name = $event.target.value"/>
    </div>

    <div class="space-y-1">
      <inputs-label for="email_address" title="Email Address"/>

      <inputs-email :required="true" for="email_address" placeholder="joe@doe.com"
                    @set="form.email = $event.target.value"/>
    </div>

    <div class="space-y-1">
      <inputs-label for="password" title="Password"/>

      <inputs-password :required="true" for="password" @set="form.password = $event.target.value"/>
    </div>

    <inputs-select id="timezone" class="col-span-6 sm:col-span-3"
                   title="Timezone"
                   :items="timezones"
                   :value="form.timezone"
                   @set="form.timezone = $event.target.value"/>

    <button class="btn-primary-md w-full" type="submit">
      Register
    </button>
  </form>
</template>

<script setup>
import {applyValidation} from "~/helpers/validation"
import {useApi} from "~/composables/api.js"

const router = useRouter()

const timezones = ref([])
const form = reactive({
  name: null,
  email: null,
  password: null,
  timezone: null,
})

onMounted(() => getTimezone())

function register() {
  useApi('auth/register', {
    method: 'POST',
    body: JSON.stringify(form),
  })
      .then((response) => {
        router.push(`/auth/verify/email?email=${form.email}`)
      })
      .catch(error => applyValidation(error.response._data.errors, Object.keys(form)))
}

function getTimezone() {
  useApi('auth/get-timezone', {
    method: 'POST',
  })
      .then((response) => {
        timezones.value = response.data
        form.timezone = response.meta.current_timezone
      })
}
</script>
